export default {
  listTab: {
    newsAggregators: 'News Aggregator',
    autoNews: 'Auto News',
    premiumAnalysis: 'FiinTrade Diary',
    expertView: 'FiinTrade Call',
  },
  exportViewTime: {
    mostRecent: 'Most Recent',
    mostPopular: 'Most Popular',
    contributors: 'Contributor',
    favorite: 'Favorite',
  },
  listTitleTable: {
    TICKER: 'TICKER',
    NEWS: 'NEWS',
    SOURCE: 'SOURCE',
    TIME: 'TIME', // hh:mm
    CONTRIBUTOR: 'CONTRIBUTOR',
    FAVORITE: 'FAVORITE',
    RUMORS: 'RUMOR',
    TRUSTABILITY: 'TRUSTABILITY',
  },
  Trustability: 'Trustability',
  listTrustability: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
  },
  filterTime: {
    from: 'From',
    to: 'to',
  },
  date: 'Date',
};
